export default __webpack_public_path__ + "85b805e5366e60cb554ebb580475ebdc.png";